module.exports = __webpack_public_path__ + "img/334638962.52016405.jpg";